import React, { forwardRef } from "react";
import Typography from "../Typography/Typography";

const Input = (
    {
        type = "text",
        color = "white",
        className,
        value,
        onChange,
        onKeyDown,
        placeholder,
        disabled,
        isTextArea = false,
        label,
        labelClassName,
    },
    ref
) => {
    const colors = {
        white: {
            defaultTextColor: "text-white",
            defaultOutlineColor: "outline-white",
            defaultBorderColor: "border-white",
            defaultColorPlaceholder: "placeholder-colorForPlaceholderInput",
        },
        blue: {
            defaultTextColor: "text-colorPrimary",
            defaultOutlineColor: "outline-colorPrimary",
            defaultBorderColor: "border-colorPrimary",
            defaultColorPlaceholder: "placeholder-[#A6A6BD]",
        },
        softBlue: {
            defaultTextColor: "text-white",
            defaultOutlineColor: "outline-white",
            defaultBorderColor: "border-white",
            defaultColorPlaceholder: "placeholder-[##A6A6BD]",
        },
        gray: {
            defaultTextColor: "text-rebrandText",
            defaultOutlineColor: "outline-rebrandStroke",
            defaultBorderColor: "border-rebrandStroke",
            defaultColorPlaceholder: "placeholder-[#A6A6BD]",
        },
    };

    // Darwin Pro, matching FormSelect and FormMultiselect and the rest of MRG.
    // Royal Momentum and Royal Bridge have their own copy at
    // RoyalMomentum/components/FormInput, which stays on Open Sans — the design
    // change that introduced it was for those two products, and applying it here
    // pulled MRG along with it.
    const fixClassName = `rounded w-full font-darwinProRegular text-base tracking-wider ${colors[color].defaultTextColor} p-4 ${colors[color].defaultOutlineColor} border ${colors[color].defaultBorderColor} bg-transparent ${colors[color].defaultColorPlaceholder} placeholder:font-darwinProRegular ${className}`;

    return (
        <div className="w-full">
            {label && (
                <Typography type="body3" className={`mb-3 ${labelClassName}`}>
                    {label}
                </Typography>
            )}
            {!isTextArea ? (
                <input
                    ref={ref}
                    type={type ? type : "text"}
                    className={fixClassName}
                    value={value || ""}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            ) : (
                <textarea
                    ref={ref}
                    rows={5}
                    className={fixClassName}
                    value={value || ""}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

const FormInput = forwardRef(Input);

export default FormInput;
